import * as service from './service'
export default {
  namespace: 'accidentTransferCarRescue',
  state: {
    demoData: {}
  },
  effects: {
    * partnerList ({ payload }, { call, put }) {
      const { data } = yield call(service.partnerList, payload)
      if (data.status === 200) {
        return data.data
      } else {
        return Promise.reject()
      }
    },
    * jumpInfo ({ payload }, { call, put }) {
      const { data } = yield call(service.jumpInfo, payload)
      if (data.status === 200) {
        return data.data
      } else {
        return Promise.reject()
      }
    }

  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
